export class Agency {
    id = '';
    name = '';
    code = '';
    status = '';
}